<template><div /></template>
<script>
export default {
  name:"GoogleMapCircle",
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    circle: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localCircle: null
    };
  },
  watch: {
    circle: function(newCircle, oldCircle) {
      console.log(newCircle, oldCircle);
      if (this.localCircle !== null) this.localCircle.setMap(null);
      this.updateCircle();
    }
  },
  methods: {
    updateCircle() {
      this.localCircle = new this.google.maps.Circle({
        strokeColor: "blue",
        strokeOpacity: 0.6,
        strokeWeight: 2,
        fillColor: "blue",
        fillOpacity: 0.2,
        map: this.map,
        circle: this.circle,
        center: this.circle.position,
        radius: this.circle.radius
      });
    }
  },
  mounted() {
    this.updateCircle();
  }
};
</script>
